import { render } from "./Phone.vue?vue&type=template&id=0d419b2d&scoped=true"
import script from "./Phone.vue?vue&type=script&lang=js"
export * from "./Phone.vue?vue&type=script&lang=js"

import "./Phone.vue?vue&type=style&index=0&id=0d419b2d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d419b2d"]])

export default __exports__